import { ActivatedRouteSnapshot, UrlSegment } from '@angular/router';
import { Injectable } from '@angular/core';
import { AppRoutingKeys, QueryParamsMapType } from '@shared';
import { QueryParamsProvider } from './query-params.provider';

@Injectable()
export class QueryParamsResolver {
	public constructor(private queryParamsService: QueryParamsProvider) {}

	public resolve(_route: ActivatedRouteSnapshot): QueryParamsMapType {
		const paramState: QueryParamsMapType = AppRoutingKeys.getParamObject();

		for (const key of Object.keys(paramState)) {
			if (_route.paramMap.has(key)) {
				paramState[key] = _route.paramMap.get(key);
			}
		}

		paramState[AppRoutingKeys.urlPathEntryEdit] = this.isRouteInPath(_route, AppRoutingKeys.urlPathEntryEdit);
		paramState[AppRoutingKeys.urlPathEntryDup] = this.isRouteInPath(_route, AppRoutingKeys.urlPathEntryDup);
		paramState[AppRoutingKeys.urlPathEntryNewFrom] = this.isRouteInPath(_route, AppRoutingKeys.urlPathEntryNewFrom);

		this.queryParamsService.queryParamsObject = paramState;
		console.log("This is param state: ", paramState);
		
		return paramState;
	}

	private isRouteInPath(route: ActivatedRouteSnapshot, key: string) {
		return route.parent.url.map((urlSegment: UrlSegment) => urlSegment.path).includes(key);
	}
}
